<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article class="post-30 page type-page status-publish hentry">
          <div class="entry-content">
            <!-- CHOOSE DOMAIN NAME -->
            <div
              class="slider-moving faq-title"
              style="display: inline-block; width: 100%"
            >
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <div
                      class="parent-typed-text wow fadeIn"
                      style="text-align: left"
                    >
                      <span
                        class="mt_typed-beforetext"
                        style="color: #828282; text-align: left"
                        >PRIVACY POLICY</span
                      >
                    </div>
                  </div>
                  <!-- <div class="col-sm-12">
                    <div
                      class="parent-typed-text wow fadeIn"
                      style="text-align: left"
                    >
                      <span
                        class="mt_typed-beforetext"
                        style="
                          color: rgb(130, 130, 130);
                          text-align: left;
                          font-size: 30px;
                          line-height: 10px;
                          white-space: none !important;
                          word-break: normal;
                        "
                        >Privacy Policy 1.0
                        <br />
                        Clear Me Out <br />
                        Effective as of June 15, 2020</span
                      >
                      <br />
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- Faq Filter Section Start -->
            <div class="faq-filter">
              <div class="container">
                <div class="row">
                  <!-- Right Filter -->
                  <div class="col-md-12">
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <p>
                          This website is owned and operated by Clear Me Out
                          (Pvt.) Ltd. (business registration no. PV00216855).
                          and will be referred to as “we”, “our” and “us” in
                          this website Privacy Policy. By using this website,
                          you agree to bind to the terms of our Privacy Policy.
                          Our website www.clearmeout.com set out on this website
                          page is referred to hereinafter as “the website”.
                        </p>
                        <p>
                          The Privacy Policy relates to the collection and use
                          of personal/business information you may supply to us
                          through your conduct on the website. By using this
                          Privacy Policy, you can learn what kind of information
                          we collect, when and how we might use those
                          information, and how we secure the information.
                        </p>
                        <p>
                          We reserve the right, at our sole discretion, to
                          modify or remove portions of this Privacy Policy at
                          any time. This Privacy Policy is in addition to any
                          other terms and conditions applicable to the website.
                        </p>
                        <p>
                          We do not make any representations about third party
                          web sites that may be linked to this website.
                        </p>
                        <p>
                          We recognize the importance of protecting the privacy
                          of information collected about customers and visitors
                          to our website, in particular the information that
                          could provide opportunity to anyone to identify an
                          individual (through individual’s personal
                          information). This Privacy Policy governs the manner
                          in which your personal/business information, obtained
                          through the website, will be dealt with. This Privacy
                          Policy will be reviewed periodically and accordingly
                          you are requested to get yourself updated.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">
                          Personal and Business Information Collection
                        </h6>
                        <p>
                          Personal/business information about our customers or
                          visitors to our website is collected only when they
                          knowingly and voluntarily submit their information. We
                          may need to collect such information to provide you
                          with further services or to answer or forward any
                          requests or enquiries. It is our intention that this
                          Privacy Policy shall protect your personal/business
                          information from being dealt with, in any kind of way
                          that is inconsistent with applicable privacy laws in
                          Sri Lanka.
                        </p>
                        <p>
                          Information are collected primarily in two ways;
                          either directly from the customer/visitor or from our
                          web server logs. Whatever the way it is collected, all
                          personal/business information will be protected in our
                          custody confidentially without sharing with outsiders,
                          unless we state in the Privacy Policy or when we
                          believe in good faith that the law requires it.
                        </p>
                        <p>
                          The removal content of individual or business,
                          submitted along with relevant details, either personal
                          or business information of (i) any individual, such as
                          first and last name, date of birth, gender, address,
                          phone number, email address and the signature as well
                          as the details of national identity card or passport,
                          or (ii) any business establishment, such as company
                          name and company details, or (iii) any personal and
                          business information and/or data of all the documents
                          submitted to us, will be disclosed to us when using
                          our services.
                        </p>
                        <p>
                          Whenever you fill in a contact form on this website,
                          we will be asking you to provide some personal
                          information such as your name, phone number and e-mail
                          address. Also, if you want to have an online chat
                          through this website, you will be asked to provide
                          information such as your name, phone number and e-mail
                          address. The information you provide to us through
                          contact forms or when having online chats will be used
                          primarily to respond to your inquiry.
                        </p>
                        <p>
                          Similarly, our “Support Center” (customer portable)
                          will ask your name, email address and phone number
                          when you forward queries/problems and our “Our
                          Newsletter &amp; Communication” will keep the records
                          of your e-mail address when you submit it to our
                          website.
                        </p>
                        <p>
                          In aforementioned events, you should be vigilant not
                          to submit any confidential, proprietary or sensitive
                          personally identifiable information such as credit
                          card, bank account or other financial particulars, or
                          date of birth, national identity card/passport/driver
                          license number, or social security number. It is
                          important to note that all submissions of sensitive
                          information, you do at your own risk and we will not
                          be liable to you or responsible for any consequences
                          arising from such submissions.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Web Server Logs</h6>
                        <p>
                          At each of your visits to our website, our web servers
                          will automatically capture the information about your
                          visit and store that information electronically in web
                          server logs, which will become records of the
                          activities on our sites. In this process we may
                          collect information such as (i) your unique Internet
                          protocol (IP) address, (ii) the name of your unique
                          Internet service provider, (iii) the town/city,
                          county/state and country from which you access our
                          website, (iv) the kind of browser or computer you use,
                          (v) the number of links you click within the site,
                          (vi) the date and time of your visit, (vii) the web
                          page from which you arrived to our site, (viii) the
                          pages you viewed on the site, and (ix) certain
                          searches /queries that you conducted via our
                          website(s).
                        </p>
                        <p>
                          The collection of information through our web server
                          logs is performed securely and effectively and used to
                          administer the website, protect the website and its
                          contents from inappropriate use as well as improve
                          user facilities.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Use of Information</h6>
                        <p>
                          Personal/business information that customers/visitors
                          submit to the website is used only for the purpose for
                          which it is submitted or for such other secondary
                          purposes that are related to the primary purpose,
                          unless we disclose other uses in this Privacy Policy
                          or at the time of collection. Copies of correspondence
                          sent from the website, that may contain
                          personal/business information, are stored as archives
                          for record-keeping and back-up purposes only.
                        </p>
                        <p>
                          Further, the information you provide to us when
                          getting “Our Newsletter &amp; Communication” will be
                          used for communicating our news and future updates. If
                          you do not wish to receive such communications, you
                          may opt out by unsubscribing.
                        </p>
                        <p>
                          The information we gather through our contacts with
                          you in conducting research surveys such as getting
                          your opinions about our current services or of
                          potential new services that may be offered, are too
                          will be stored as archives after using for the
                          particular purpose.
                        </p>
                        <p>
                          We collect personal/business information from you and
                          process them in an appropriate manner to provide you
                          the best possible service you have requested from us.
                        </p>
                        <p>
                          As a rule, we do not sell, rent or lease our customer
                          details, particularly the customer lists to any third
                          parties. Further, if an external business partner
                          makes an offer that may be relevant to you as per our
                          opinion, we may contact you on behalf of the external
                          party with regard to that particular offer. However,
                          in such incidents your personal information such as
                          your first and last name, date of birth, gender,
                          address, phone number, email address and the signature
                          as well as the details of national identity card or
                          passport, or your business information such as company
                          name and company details, submitted to us along with
                          removal contents would not be transferred to the third
                          party. Further, in our processes, we may interact with
                          trusted external partners with the aim of getting
                          their help for our statistical analysis, sending your
                          emails or postal mails, or providing customer support.
                          However, all such external partners are prohibited
                          from using your personal information except for above
                          mentioned particular purposes.
                        </p>
                        <p>
                          To get an understanding on popularity of our services
                          among customers, we keep track of the websites and
                          pages our customers visit within clearmeout.com. Such
                          data we maintain confidentially and will be used for
                          the benefits of both the parties, customers and our in
                          lawful manner.
                        </p>
                        <p>
                          Further, we may transfer your personal and/or business
                          information outside the country of your residence
                          and/or where your business is established, for the
                          purposes set out in this Privacy Policy. By submitting
                          your personal/business information, you are consenting
                          to such transfers.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">
                          Disclosure of Information
                        </h6>
                        <p>
                          Apart from where you have consented or the disclosure
                          is necessary to achieve the purpose for which it was
                          submitted, personal information may be disclosed in
                          special situations where we have reason to believe
                          that doing so is necessary to identify, contact or
                          bring legal action against anyone damaging, injuring,
                          or interfering either intentionally or unintentionally
                          with our rights or property, customers/ visitors, or
                          anyone else who could be harmed by such activities.
                          Also, we may disclose personal information when we
                          believe in good faith that the law requires
                          disclosure.
                        </p>
                        <p>
                          We may engage third parties to provide you with
                          services on our behalf and in such circumstances, we
                          may disclose your personal information to those third
                          parties in order to meet your request for services.
                        </p>
                        <p>
                          We never use or disclose your sensitive personal
                          information, such as race, religion, or political
                          affiliations, without your explicit consent.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Cookies and Applets</h6>
                        <p>
                          Cookies are text files stored on the client computer
                          and they are kept for various information tracking
                          purposes. We use cookies to provide you with a better
                          experience. These cookies allow us to increase your
                          information security by storing your session ID and
                          are a way of monitoring single user access.
                        </p>
                        <p>
                          The aggregate of Cookies and Applets assists us in
                          analyzing the usage of the site by collating and
                          providing non-personal information of our users.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">IP Addresses</h6>
                        <p>
                          Our web servers gather your IP address to assist with
                          the diagnosis of problems or support issues with our
                          services. Further, we gather information in aggregates
                          only and therefore, we cannot trace back any
                          individual user.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Information Security</h6>
                        <p>
                          We strive to ensure the security, integrity and
                          privacy of personal/business information submitted to
                          our sites, and we review and update our security
                          measures in light of current technologies. We always
                          make the maximum effort to secure all the personally
                          identifiable information you provide to us in a
                          controlled, secured environment, protecting them from
                          unauthorized access, use or disclosure. However, no
                          one can guaranty the data transmission over the
                          Internet is totally secure.
                        </p>
                        <p>
                          With such difficult challenges, we will endeavour to
                          take all reasonable steps to protect the personal/
                          business information you may transmit to us online and
                          once we receive them, we will make our best efforts to
                          ensure their maximum security on our systems.
                        </p>
                        <p>
                          In addition, our employees and the contractors who
                          provide services related to our information systems
                          are obliged to respect the confidentiality of any
                          personal information held by us. However, we will not
                          be held responsible for events arising from
                          unauthorized access to your personal information.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">
                          Accuracy and Correctness of Information
                        </h6>
                        <p>
                          We will endeavour to take all reasonable steps to keep
                          accurate and up to date all information which we hold
                          about you/your business, and to keep them secure. If,
                          at any time, you discover that information held about
                          you/your business is incorrect, you may contact us to
                          have the information corrected.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Links to Other Web Sites</h6>
                        <p>
                          We provide links to web sites outside of our website,
                          in accordance with our requirements. However, these
                          linked sites are not under our control, and we cannot
                          accept responsibility for the conduct of companies
                          linked to our website. Therefore, before disclosing
                          your personal/business information on any other web
                          site, we advise you to examine the terms and
                          conditions of using that web site and its privacy
                          statement. We will not pass any personal/business
                          information collected through this website to any
                          third party for their use without your consent.
                        </p>
                      </span>
                    </div>
                    <div class="full-faq">
                      <!-- Question 1 -->
                      <span>
                        <h6 style="color: #828282">Issues and Queries</h6>
                        <p>
                          If we become aware of any ongoing concerns or problems
                          with our website, we will take such issues seriously
                          and work to address those concerns.
                        </p>
                        <p>
                          If you have any further queries relating to our
                          Privacy Policy, or you have a problem or if you think
                          that we have not adhered to this Privacy Policy
                          adequately, you may contact us at
                          legal@clearmeout.com, so we will be able to determine
                          the cause and take prompt remedial actions if any
                          required.
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Faq Filter Section End -->
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/

export default {
  name: "personal_harassment",
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
      faqList: [],
    };
  },
  mounted() {
    const $this = this;

    jQuery.get("https://staging.clearmeout.com/faq.json").done(function (data) {
      console.log("data", data);
      const _data = Object.values(data);
      $this.faqList = _data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Faq Section CSS */
.faq-filter {
  padding: 80px 0 80px;
}
.faq-filter .filter ul {
  padding: 0;
}
.faq-filter .filter li {
  list-style: none;
}
.faq-filter .filter button {
  outline: none;
}
.faq-filter .filter {
  text-align: center;
  /*box-shadow: 1px 3px 6px rgba(0,0,0,0.16), inset 2px 1px 6px rgba(0,0,0,0.23);*/
}
.faq-filter .filter button {
  border: none;
  background-color: #6773dd;
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-bottom: 1px solid #cac8c885;
  color: #fff;
}
.faq-filter .filter button:hover {
  background-color: #6773dd;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.faq-filter .filter .faq1 button {
  color: #fff;
}
.faq-filter .filter:hover .faq1 button {
  color: #6773dd;
}
.faq-filter .filter .faq1 button:hover {
  color: #fff;
}

.faq-filter .card-header button {
  font-size: 18px;
  padding-bottom: 0;
}
.faq-filter .full-faq {
  outline: none;
}
.faq-filter .full-faq h2 {
  color: #63b966;
  margin: 0;
  font-size: 30px;
  letter-spacing: -0.1px;
  margin-bottom: 32px;
}
.faq-filter #Personal,
#Business h2 {
  margin-top: 36px;
}
.faq-filter .full-faq h6 {
  color: #6773dd;
  font-size: 20px;
  font-weight: 400;
  margin: 13px 0 7px;
}
.faq-filter .full-faq p {
  font-size: 15px;
  line-height: 25px;
  font-family: Nunito;
  color: #828282;
  letter-spacing: -0.1px;
  margin-bottom: 25px;
}
.faq-filter .full-faq .bottom-divider {
  border-top: 1px solid #e8e8e8;
  padding-bottom: 40px;
  margin-top: 40px;
}

.faq-title .mt_typed-beforetext {
  color: #6f85ff;
  font-size: 46px;
}
.faq-title .parent-typed-text {
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy.vue